export default "__VITE_ASSET__CQ_T_4PM__"